import React, { useEffect, useState } from 'react'
import TextBox from '../Generales/TextBox'



const ComponentLista = ({ pregunta, onChange, value }) => {

    const array = []

    const [valores, setValores] = useState([])

    useEffect(() => {

        console.log('valuePregunta', value)

        if (value) {
            setValores(value)

        } else {
            if (pregunta) {
                var varloresAuxPrincipal = []
                var valoresAux = []
                pregunta.cuesOpcionesLista.forEach((opcion, index) => {

                    valoresAux.push(opcion.opcion)
                });
                if (valoresAux.length > 0) {
                    // varloresAuxPrincipal.push(valoresAux)
                }
                Array.from({ length: pregunta.cuesOpcionListaFilas }, (_, i) => {

                    var valoresAux2 = []

                    pregunta.cuesOpcionesLista.forEach((opcion, index) => {

                        valoresAux2.push('')

                    });
                    if (pregunta.cuesOpcionesLista.length == 0) {
                        valoresAux2.push('')
                    }
                    varloresAuxPrincipal.push(valoresAux2)

                })
                setValores(varloresAuxPrincipal)
                onChange(varloresAuxPrincipal)
            }
        }







    }, [])






    return (
        <div>


            <table className='table table-bordered'>
                {pregunta.cuesOpcionesLista.length > 0 &&

                    <thead>
                        <tr>
                            {pregunta.cuesOpcionesLista.map((opcion) => {
                                return (
                                    <th>{opcion.opcion}</th>

                                )
                            })}

                        </tr>


                    </thead>

                }

                <tbody>

                    {valores.map((row, indexR) => {
                        return (
                            <tr>
                                {row.map((column, indexC) => {
                                    return (

                                        <td>

                                            <TextBox
                                                tabIndex="1"
                                                type={'text'}
                                                value={column}

                                                classNameInput={"form-control"}
                                                placeholder={'Ingrese un valor'}
                                                onChange={(valor, e) => {

                                                    var cloneAux = [...valores]

                                                    cloneAux[indexR][indexC] = valor

                                                    setValores(cloneAux)

                                                }}
                                                validate={false}
                                                validationCallback={res => {
                                                }}
                                                validationOption={{
                                                    type: 'string',

                                                }}
                                            />
                                        </td>
                                    )

                                })}
                            </tr>
                        )
                    })}


                </tbody>
            </table>





        </div>
    )

}
export default ComponentLista